import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    container: {
      flex: '1 1',
      overflow: 'hidden',
      position: 'relative',
      marginBlock: -32,
      marginInline: -40,
      '& > .qiankun-micro-app-wrapper': {
        position: 'relative',
        minHeight: 'calc(100% - (48px + 56px)) !important',
        '& #root': {
          overflow: 'auto',
          '& .ant-pro-layout-bg-list': {
            display: 'none'
          },
          '& .ant-pro-layout .ant-pro-sider.ant-pro-sider-fixed': {
            insetBlockStart: 'calc(48px + 56px) !important',
            height: 'calc(100% - (48px + 56px)) !important'
          }
        }
      }
    },
    containerWithoutLayout: {
      '& .qiankun-micro-app-wrapper': {
        height: '100vh',
        '& > .qiankun-micro-app-container': {
          '&, & > div': {
            height: '100%'
          }
        }
      }
    }
  };
});